(function(){
  var track=document.getElementById('aur-diffusers-track');
  if(!track)return;
  var cards=track.querySelectorAll('.aur-card');
  var dots=document.querySelectorAll('.aur-diffusers__dot');
  var arrowL=document.querySelector('.aur-diffusers__arrow--left');
  var arrowR=document.querySelector('.aur-diffusers__arrow--right');
  function gw(){return cards[0].offsetWidth+16}
  function getCardCenter(i){return cards[i].offsetLeft+cards[i].offsetWidth/2}
  function closest(){var c=0,m=Infinity,center=track.scrollLeft+track.offsetWidth/2;for(var i=0;i<cards.length;i++){var d=Math.abs(center-getCardCenter(i));if(d<m){m=d;c=i}}return c}
  function ud(){var idx=closest();for(var i=0;i<dots.length;i++){if(i===idx){dots[i].classList.add('aur-diffusers__dot--active')}else{dots[i].classList.remove('aur-diffusers__dot--active')}}}
  function si(index,smooth){var t=getCardCenter(index)-track.offsetWidth/2;track.scrollTo({left:Math.max(0,t),behavior:smooth?'smooth':'auto'})}
  function sb(dir){track.scrollBy({left:dir*gw(),behavior:'smooth'})}
  track.addEventListener('scroll',ud,{passive:true});
  if(arrowL)arrowL.addEventListener('click',function(){sb(-1)});
  if(arrowR)arrowR.addEventListener('click',function(){sb(1)});
  for(var i=0;i<dots.length;i++){dots[i].addEventListener('click',(function(idx){return function(){si(idx,true)}})(i))}
  function center(){si(2,false)}
  if(document.readyState==='complete'){center()}else{window.addEventListener('load',center)}
  setTimeout(function(){si(2,false)},150);
})();